import { Container } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { APP_NAME } from './../utils/constants';
import Navbar from './Navbar';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
    title?: string
}

const Layout: FunctionComponent<LayoutProps> = ({ title, children }) => {
    return (
        <React.Fragment>
            <div style={{ minHeight: "95vh" }}>
                <Helmet>
                    <title>{APP_NAME} {title ? `| ${title}` : ""} </title>
                </Helmet>

                <Navbar title={`${APP_NAME} ${title ? `| ${title}` : ""}`} />

                <Container style={{ marginTop: 35, marginBottom: 35 }}>

                    <Header />

                    {children}
                </Container>
            </div>
            <Footer />
        </React.Fragment>
    );
};

export default Layout;